import React from 'react';
import clsx from 'clsx';
import { Button, LabelShowingResults, Spinner } from '@/components/common';
import { Input } from '@/components/form';
import Icons from '@/const/icons';
import { useFilters } from '@/hooks';
import { useForm } from 'react-hook-form';

interface Props {
	total: number;
	totalItems: number;
	isDownload: boolean;
	countDownload: number;
	downloadEnabled: boolean;
	onClickDownload: () => void;
}

export const Header: React.FC<Props> = ({
	total,
	totalItems,
	countDownload,
	downloadEnabled,
	isDownload,
	onClickDownload,
}) => {
	const { searchFilter } = useFilters();
	const { register } = useForm();

	return (
		<div className="mt-6 flex items-center justify-between">
			<div className="flex items-center gap-4">
				<Button
					onClick={onClickDownload}
					disabled={downloadEnabled || isDownload}
					decoration="secondary"
					size="small"
				>
					{isDownload && <Spinner className="w-2 h-2 mr-2" />}
					Download
					{countDownload > 0 && (
						<span className="ml-1">{`x${countDownload}`}</span>
					)}
				</Button>
			</div>
			<div className="flex items-center gap-2">
				<Input
					name="search"
					register={register}
					placeholder="Search"
					iconLeft={Icons.search}
					className="w-full"
					classNameIcon={'!top-[23%] !w-4 !h-4 text-opacity-black'}
					classNameInput={clsx(
						'pl-9 !w-[268.54px] !bg-gray-15 !h-[33px] !m-0 border-none'
					)}
					onChange={({ target }) => searchFilter(target.value)}
					disabled={isDownload}
				/>
				<LabelShowingResults
					totalItems={totalItems}
					labelTotalItems="clients"
					total={total}
					allowDynamicUpdate
				/>
			</div>
		</div>
	);
};
